export default "__VITE_ASSET__DlTwaLqy__"